import React from "react"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"

const AboutUs=()=>(
    <div className="aboutUs">
        <Row>
            <Col md={6} sm={12} className="answerPanel">
                <div className="verticalText">
                    <h2>About us</h2>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor 
                        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud 
                        exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute 
                        irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat 
                        nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa 
                        qui officia deserunt mollit anim id est laborum
                    </p>
                </div>
            </Col>
            <Col md={6} sm={12} className="questionPanel">
                <div className="verticalText">
                    <h2>Why to choose us?</h2>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor 
                        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud 
                        exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute 
                        irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat 
                        nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa 
                        qui officia deserunt mollit anim id est laborum
                    </p>
                </div>
            </Col>
        </Row>
    </div>
)

export default AboutUs